<template>
  <div id="slider" class="home-grid">
    <section class="home-main">
      <div class="sl-panel stream-card">
        <div class="stream-card__bar">
          <span class="stream-card__channel">{{ active.name }}</span>
          <a
            class="stream-card__out"
            :href="channelUrl"
            target="_blank"
            rel="noopener"
          >Watch on Twitch &#8599;</a>
        </div>
        <div class="stream-card__video">
          <iframe
            :key="active.twitch_id"
            :src="active.url"
            allowfullscreen
            frameborder="0"
            scrolling="no"
          ></iframe>
        </div>
      </div>

      <div class="channel">
        <div class="channel__avatar">
          <img :src="active.prof_pic" :alt="active.name" />
        </div>
        <div class="channel__body">
          <h1 class="channel__name">{{ active.name }}</h1>
          <p class="channel__desc">{{ active.description }}</p>
        </div>
        <div class="channel__actions">
          <a class="sl-btn sl-btn--red" :href="channelUrl" target="_blank" rel="noopener">Watch</a>
          <a class="sl-btn sl-btn--purple" :href="subscribeUrl" target="_blank" rel="noopener">Subscribe</a>
        </div>
      </div>
    </section>

    <aside class="home-rail">
      <div>
        <div class="sl-section-head"><h2>Featured</h2></div>
        <div class="home-rail__list">
          <streamSlide
            v-for="(channel, index) in featuredChannels"
            v-bind:key="channel.twitch_id"
            v-bind:channel_data="channel"
            v-bind:active="index === activeIndex"
            v-on:select="setActive(index)"
          ></streamSlide>
        </div>
      </div>

      <div class="bounty-teaser">
        <div class="bounty-teaser__title">Sub Bounties</div>
        <p class="bounty-teaser__copy">
          Check the current sub bounties - grab some swiftbucks!
        </p>
        <button class="sl-btn sl-btn--red sl-btn--block" @click="goBounties">View Bounties &#8594;</button>
      </div>
    </aside>
  </div>
</template>

<script>
import streamSlide from './stream-slide'
export default {
  name: 'slider',
  components: {
    streamSlide
  },
  computed: {
    active () {
      return this.featuredChannels[this.activeIndex]
    },
    channelSlug () {
      return this.active.name.toLowerCase()
    },
    channelUrl () {
      return `https://www.twitch.tv/${this.channelSlug}`
    },
    subscribeUrl () {
      return `https://www.twitch.tv/subs/${this.channelSlug}`
    }
  },
  methods: {
    setActive (index) {
      this.activeIndex = index
    },
    goBounties () {
      this.$router.push({ path: '/bounties' })
    }
  },
  data () {
    return {
      activeIndex: 0,
      featuredChannels: [
        {
          name: 'Swiftor',
          url: 'https://player.twitch.tv/?channel=swiftor&parent=swiftorland.com',
          twitch_id: '274625',
          prof_pic: 'https://static-cdn.jtvnw.net/jtv_user_pictures/2174635e-aa4c-42e0-b00b-d1fb6bff9cf0-profile_image-300x300.png',
          banner: 'https://static-cdn.jtvnw.net/jtv_user_pictures/2174635e-aa4c-42e0-b00b-d1fb6bff9cf0-profile_image-300x300.png',
          // `meta` is the short line shown in the Featured rail; `description`
          // is the longer blurb shown only for the channel you're watching
          meta: 'Main channel',
          description: 'Gaming with the community since 2008. As the face of SwiftRage, poor anger management comes standard.'
        }, {
          name: 'Spin247',
          url: 'https://player.twitch.tv/?channel=spin247&parent=swiftorland.com',
          twitch_id: '276400590',
          prof_pic: 'https://static-cdn.jtvnw.net/jtv_user_pictures/0623e8bb-24b5-4d81-8138-b976afe9dbe9-profile_image-70x70.png',
          banner: 'https://static-cdn.jtvnw.net/jtv_user_pictures/0623e8bb-24b5-4d81-8138-b976afe9dbe9-profile_image-300x300.png',
          meta: 'Live 24/7',
          description: 'Play roulette using swiftbucks, Live 24/7'
        }, {
          name: 'SwiftorCasino',
          url: 'https://player.twitch.tv/?channel=swiftorcasino&parent=swiftorland.com',
          twitch_id: '432195675',
          prof_pic: 'https://static-cdn.jtvnw.net/jtv_user_pictures/c2e99394-1e2a-4d48-b942-5a804c4cf052-profile_image-70x70.png',
          banner: 'https://static-cdn.jtvnw.net/jtv_user_pictures/9e32e0d7-d202-49d6-a6d4-6381fc27af6d-profile_banner-480.jpeg',
          meta: 'Swiftor community channel',
          description: 'Live dealer games for Swiftbucks. Channel is part of the Swiftor community. General Manager: Annorax10 Assistant GM: Reptile__dysfunctionShift Managers:Pit Bosses:Dealers: Annorax, Reptile, Ryygaming'
        }
      ]
    }
  }
}
</script>

<style scoped>
.home-grid {
  display: grid;
  grid-template-columns: 1fr 340px;
  gap: 28px;
  align-items: start;
  text-align: left;
}

.home-main {
  min-width: 0;
}

/* ----------------------------------------------------------- stream card */

.stream-card {
  background: var(--sl-ink);
  box-shadow: var(--sl-shadow-lg);
  border-color: rgba(255, 255, 255, 0.09);
}

.stream-card__bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 14px;
  background: linear-gradient(90deg, var(--sl-red), var(--sl-red-dk));
  font-family: var(--sl-font-cond);
}

.stream-card__channel {
  font-weight: 800;
  font-size: 14px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #fff;
}

.stream-card__out {
  font-weight: 700;
  font-size: 13px;
  color: #fff;
  opacity: 0.92;
  text-decoration: none;
  white-space: nowrap;
}

.stream-card__out:hover {
  opacity: 1;
  text-decoration: underline;
}

.stream-card__video {
  position: relative;
  width: 100%;
  padding-top: 56.25%;
  background: repeating-linear-gradient(45deg, #0c0c10 0 12px, #101015 12px 24px);
}

.stream-card__video iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}

/* --------------------------------------------------------- channel block */

.channel {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 18px;
}

.channel__avatar {
  width: 58px;
  height: 58px;
  flex-shrink: 0;
  border-radius: 50%;
  padding: 2px;
  background: linear-gradient(135deg, var(--sl-red), var(--sl-purple));
  box-sizing: border-box;
}

.channel__avatar img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  display: block;
  background: var(--sl-surface);
}

.channel__body {
  flex: 1;
  min-width: 0;
}

.channel__name {
  font-family: var(--sl-font);
  font-weight: 800;
  font-size: 26px;
  letter-spacing: -0.3px;
  margin: 0;
}

.channel__desc {
  color: var(--sl-muted);
  font-size: 14.5px;
  margin: 2px 0 0;
  line-height: 1.4;
}

.channel__actions {
  display: flex;
  gap: 10px;
  flex-shrink: 0;
}

/* ------------------------------------------------------------------ rail */

.home-rail {
  display: flex;
  flex-direction: column;
  gap: 22px;
  min-width: 0;
}

.home-rail__list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.bounty-teaser {
  background: linear-gradient(180deg, rgba(224, 31, 40, 0.14), rgba(20, 20, 25, 0.6));
  border: 1px solid rgba(224, 31, 40, 0.35);
  border-radius: 14px;
  padding: 18px;
}

.bounty-teaser__title {
  font-family: var(--sl-font-cond);
  font-weight: 800;
  font-size: 18px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.bounty-teaser__copy {
  font-size: 13.5px;
  color: #b6b6be;
  margin: 6px 0 14px;
  line-height: 1.45;
}

@media (max-width: 980px) {
  .home-grid {
    grid-template-columns: 1fr;
  }
  .channel {
    flex-wrap: wrap;
  }
  .channel__actions {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/slider.vue